import { RevCard, RevTextArea } from "@revmatics/catalyst";
import { useFormContext } from "react-hook-form";
import { BrandEditByIdBodyType } from "../../../../../../stores/types/brandTypes.tsx";
import { useTrimmedRegister } from "../../../../../../helpers/hooks/useTrimmedRegister.ts";

type Props = {
  readAccessOnly: boolean;
};

export const BrandGuidelinesBrandSafetyView = ({ readAccessOnly }: Props) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<BrandEditByIdBodyType>();

  const registerTrimmed = useTrimmedRegister(register);

  return (
    <RevCard
      title="Brand safety"
      text="Brand safety guidelines ensure you keep your brand’s reputation safe when advertising online. This can be different for every brand."
      paddingTitle="py-4 px-6"
      textColor="text-monochrome-900"
      textSize="typography-body-sm"
    >
      <RevTextArea
        name="brand_safety"
        label="Description"
        placeholder={readAccessOnly ? "N/A" : "Enter brand safety"}
        size="md"
        rows={5}
        register={registerTrimmed("brand_safety")}
        error={errors.brand_safety}
        useLength={false}
        disabled={readAccessOnly}
      />
    </RevCard>
  );
};
